<template>
    <div class="vrm-installations-filter-indicator">
        <div class="vrm-installations-filter-indicator__label">
            <span
                v-if="isFiltered"
                v-html="
                    $t('installationoverview.filter_results_count', {
                        i18nFallback: '<strong>{count}</strong> results match your filters.',
                        count: count,
                    })
                "
            ></span>
            <span
                v-else
                v-html="
                    $t('installationoverview.filter_results_all', {
                        i18nFallback: 'All <strong>{count}</strong> installations shown.',
                        count: count,
                    })
                "
            ></span>
        </div>

        <div v-if="isFiltered" class="vrm-installations-filter-indicator__action">
            <a href="#" @click="clear()">
                {{
                    $t('installationoverview.filter_button_clear_all', {
                        i18nFallback: 'Clear all filters',
                    })
                }}
            </a>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component({
    emits: ['clear'],
})
@AngularDirective('vrm-installations-filter-indicator')
export default class VrmInstallationsFilterIndicator extends Vue {
    /**
     * The visible installation count for the user, after filters are applied.
     */
    @Prop({ type: Number, default: 0 })
    count;

    /**
     * Total installation count for the signed-in user.
     */
    @Prop({ type: Number, required: true })
    total;

    /**
     * If the current count is smaller than the total installation count, some filter is applied.
     *
     * @returns {boolean}
     */
    get isFiltered() {
        return this.count < this.total;
    }

    /**
     * Emits a 'clear' event to the parent component to reset any applied filters.
     */
    clear() {
        this.$emit('clear');
    }
}
</script>
